import require from './index'

export function getAlarmDetail (params) {
  const { url, data } = params
  return require.get(url, data)
}

export function getHandleType (params) {
  const { url, data } = params
  return require.get(url, data)
}

export function getReadState (params) {
  const { url, data } = params
  return require.post(url, data)
}
